const API_KEY = "oVWyroF7xCBmAhUE"
const BASE = "https://api.songkick.com/api/3.0"
const ARTIST_ID = "9714884"
// const ARTIST_ID = "379603"

export default {
  calendar: async () => {
    return await fetch(BASE + `/artists/${ARTIST_ID}/calendar.json?apikey=${API_KEY}`)
  }
}